import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';

export interface Rppk16QueryParams {
  siteId: number;
  clientId?: number | null;
  vehicleTypeId?: number | null;
}

@Injectable({ providedIn: 'root' })
export class ApiRppk16Service {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);
  private readonly http = inject(HttpClient);

  getRppk16ForTable(query: Rppk16QueryParams): Observable<unknown> {
    const token = this.cookieService.get('token');
    const params: Record<string, string | number> = { siteId: query.siteId };
    if (query.clientId && query.clientId > 0) params['clientId'] = query.clientId;
    if (query.vehicleTypeId && query.vehicleTypeId > 0) params['vehicleTypeId'] = query.vehicleTypeId;

    return this.apiMethodService.request('/FinanceReports/getRppk16ForTable', 'GET', this.baseUrl, {
      isConsoleLog: false,
      labelLog: 'getRppk16ForTable',
      token,
      headerOnly: false,
      params,
    });
  }

  getRppk16Pdf(query: Rppk16QueryParams): Observable<Uint8Array> {
    const token = this.cookieService.get('token');
    let params = new HttpParams().set('siteId', String(query.siteId));
    if (query.clientId && query.clientId > 0) params = params.set('clientId', String(query.clientId));
    if (query.vehicleTypeId && query.vehicleTypeId > 0) {
      params = params.set('vehicleTypeId', String(query.vehicleTypeId));
    }

    return this.http
      .get(`${this.baseUrl}/Reports/rppk16/pdf`, {
        headers: new HttpHeaders({ Authorization: `Bearer ${token}` }),
        params,
        responseType: 'arraybuffer',
      })
      .pipe(map((buf) => new Uint8Array(buf)));
  }
}
